


































































































import Vue from 'vue'
import dayjs from 'dayjs';

import HistoryDataChart from './HistoryDataChart.vue'

export default Vue.extend({
  components: {
    HistoryDataChart
  },
  
  props:{
    tabsdData:{
      type: Array,
      default:() => ([])
    },
    data:{
      type: Array,
      default:() => ([])
    },
    process:{
      type: Array,
      default:() => ([])
    },
    loading:{
      type: Boolean,
      default: false
    },
    historyData:{
      type: Object,
      default: ()=>undefined
    }
  },
  data() {
    return {
        defaultActiveKey: 0,
        propertyVisible: false,
        propertySelected:[],
        tableColumns: [],
        tableData: [],
        bizTypeList: [6,8,11],
        scrollHeight: 200,
        showType:'bar',
    }
  },
  computed: {
    chartDataList(){
      if(!this.historyData){
        return [];
      }
      const list = this.historyData.tableHeaderList
        .filter(c=>c!=='time')
        .map(c=>{
          const dataList = this.historyData
            .tableData
            .map(x=>({
              value: x[c]==='' || x[c]==='-'? undefined: Number(x[c]),
              time: x['time'],
              name: c,
            })).filter(x=>x.value!==undefined);
          return {
            label: c,
            dataList,
          }
        });
      return list.filter(x=>x.dataList.length);
    },
    dataValue(){
      return this.data;
    },
    tableColList(){
      if(!this.historyData){
        return [];
      }
      return this.generateCol(this.historyData.tableHeaderList);
    },
    tableDataList(){
      if(!this.historyData){
        return [];
      }
      if(!this.historyData.tableData){
        return [];
      }
      return this.historyData.tableData;
      
    }
  },
  mounted() {
    // this.initTableColumns()
    this.resetTableScrollHeight()
  },
  created() {
  },
  destroyed() {
  },
  methods: {
    organizeData(item) {
      const arr = item.split("~")
      const year = dayjs(arr[0]).format('YYYY')
      const day = dayjs(arr[0]).format('YYYY-MM-DD')
      arr[0] = arr[0].replace(year + "-","")
      arr[1] = arr[1].replace(day + " ","")
      const value = arr.join("~")
      return value
    },
    generateCol(headerList){

      const timeHead={ 
        title: 'time', width: 150, 
        dataIndex: 'time', 
        key: 'time', 
        fixed: 'left',
        customRender:(val) => {
          return dayjs(val*1).format('mm:ss.SSS');
        },
      };

      const otherHeadList= headerList
        .filter(c=>c!=='time')
        .map((item,index)=>({
              title: item,
              dataIndex: item,
              key: item+'_'+index,
              width: 150,
              customRender:(val) => {
                if(val==='' || val=== undefined){
                  return '-';
                }
                return val;
              },
            }
          )
        );

      return [timeHead, ...otherHeadList];
    },
    onChangeTabs(value) {
      this.defaultActiveKey = value
      this.showType='bar'
      this.$emit('changeTabs',{
        value,
        propertyList: this.propertySelected
      })
      
    },
    openPropertyModal(){
      this.propertyVisible=true;
    },
    onOk(){
      this.propertyVisible=false;
      this.$emit('changeTabs',{
        value: this.defaultActiveKey,
        propertyList: this.propertySelected
      })
    },
    onCancel(){
      this.propertyVisible=false;
    },
    onPropertySelectedChange(){
      
      if(this.propertySelected && this.propertySelected.length>30){

        this.propertySelected.splice(0,1);
      
      }
    },
    resetTableScrollHeight(){
      const height = document.querySelector('.main-body').clientHeight
      this.scrollHeight = height - (92+33)
    },
    initTableColumns(){
      this.tableKey = {}
      this.tableColumns = [{
        title: this.$t('page_process_parameters_time_name'),
        dataIndex: 'time',
        key: 'time',
        width: 150
      }]
      this.dataValue.forEach(item => {
        const value = {
          title: item.paramDesc,
          dataIndex: item.id,
          key: item.id,
          width: 150,
          customRender:(val) => val !=0 ? val : '-',
        }
        this.tableKey[item.id] = '-'
        this.tableColumns.push(value)
      });
      this.initTableData()
    },
    initTableData(){
      this.tableData = []
      const dict = {}
      for(let value of this.dataValue) {
        if(value.finalEndList){
          for(let l of value.finalEndList) {
            if(!dict[l.reportTime]) {
              dict[l.reportTime] = {
                ...this.tableKey,
                reportTime: l.reportTime,
                time: dayjs(l.reportTime).format('mm:ss.SSS')
              }
            }
            dict[l.reportTime][value.id] = this.addCompany(value.unit,l.value)
          }
        } else{
          continue
        }
      }
      const dataValue = Object.values(dict)
      this.tableData = dataValue.sort((a:any, b:any) => {return a.reportTime - b.reportTime})
    },
    addCompany(unit,value){
      return value ? value + (unit ? unit : '') : '-'
    },
    handleShowTypeChange(e) {
      console.log('handleShowTypeChange:', e);
      this.showType = e.target.value
      if(this.showType==='table'){
        this.resetTableScrollHeight();
      }
    }
  },
  watch:{
    process:{
      handler(newVal,oldVal){
        if(newVal.length<=30){
          this.propertySelected=newVal.map(c=>c.paramDesc);
        }else{
          const names =[];
          for(var i=0;i<30;i++){
            names.push(newVal[i].paramDesc);
          }
          this.propertySelected=names;
        }
      }
    },
    
    data:{
      handler(newVal,oldVal){
        /*
        if(newVal.length>0){
          this.initTableColumns()
          this.getHeight()
        }else{
          this.tableData=[];
        }
        */
      }
    }
  }
})
